<template>
 <default-layout>
  <BreadcrumLayout>
   <div class="flex">
    <a href="#" class="link-color"><U>Planning</U></a>
    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mt-1" viewBox="0 0 20 20" fill="currentColor">
     <path fill-rule="evenodd"
      d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
      clip-rule="evenodd" />
    </svg>
    <a href="#" class="link-color"><U>Food Orders</U></a>
   </div>
  </BreadcrumLayout>
  <PageTitleLayout>
   <div class="w-full flex flex-wrap justify-between items-center">
    <h1 class="heading-color xl:text-4xl text-2xl font-bold text-left">Create Order</h1>

    <div class="right-button">
     <button @click="loadIsPrint"
      class="button-color text-white font-bold py-3 sm:px-8 px-4 lg:ml-6 sm:ml-6 ml-6 rounded lg:mt-0 sm:mt-0">
      PRINT
     </button>

     <inertia-link :href="route('food-orders')" class="">
      <button
       class="cancel-button-color text-white font-bold py-3 xl:px-8 sm:px-8 px-4 lg:ml-6 sm:ml-6 ml-0 rounded lg:mt-0 sm:mt-0">
       CANCEL
      </button>
     </inertia-link>

     <inertia-link
      :href="route('CreateFoodOrders-next') + `?food_create_id=${this.food_create_id}&food_create_type=${this.food_create_type}`"
      class="">
      <button
       class="cancel-button-color text-white font-bold py-3 xl:px-8 sm:px-8 px-4 lg:ml-6 sm:ml-6 ml-6 rounded lg:mt-0 sm:mt-0">
       BACK
      </button>
     </inertia-link>

     <!-- <inertia-link :href="route('foodorderdetail-next')" class=""> -->
     <button @click="CreateFoodOrder"
      class="button-color text-white font-bold py-3 sm:px-8 px-4 lg:ml-6 sm:ml-6 ml-6 rounded lg:mt-0 sm:mt-0">
      NEXT
     </button>
     <!-- </inertia-link> -->
    </div>
   </div>

  </PageTitleLayout>

  <div class="order-detail xl:px-10 px-5">
   <p class="text-base">Food Order for: {{ food_order_name }}</p>
  </div>
  <TableIndexLayout>
   <div class="food-order xl:px-10 px-5 mt-6">
    <h3 class="progress-text font-bold">Progress: Step 3 of 4</h3>
    <div class="w-full progress-bar">
     <div class="py-0.5 text-xs text-center text-white bg-green-500 w-1/2">50%</div>
    </div>
   </div>
  </TableIndexLayout>

  <PageTitleLayout>

  </PageTitleLayout>

  <div class="lg:mb-0 mb-4 w-full mt-6 flex xl:px-10 px-5">
   <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="#0093d0">
    <path fill-rule="evenodd"
     d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
     clip-rule="evenodd" />
   </svg><span class="span-text font-bold pl-1">Confirm the order quantities for each delivery location:</span>


  </div>

  <div v-if="ignoredProductsCount() > 0" class="mb-4 w-full flex xl:px-10 px-5 items-center gap-1">
   <input type="checkbox" @click="filterIgnoredProdcuts()"
    class="w-4 h-4 text-blue-600 bg-gray-100 rounded border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />
   <span class="" v-text="filterIgnoredProducts ? 'Hide ignored products' : 'Show ignored products'"></span>
  </div>

  <div v-for="(preferProduct, index) in preferProducts" :key="index">
   <header
    class="searching-background-color flex justify-between items-center py-2 pl-6 shadow overflow-hidden rounded-t-lg mx-10 mt-1">
    <h2 class="text-white text-lg font-bold w-11/12">{{ index }}</h2>
    <a title="Add Products" href="#" @click="addProductsIngredientModalOpen(index)">
     <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-white mr-3" fill="none" viewBox="0 0 24 24"
      stroke="currentColor">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
     </svg>
    </a>


    <svg v-if="!isOpenOffering.includes(index)" @click="accordianShow(index)" xmlns="http://www.w3.org/2000/svg"
     class="h-6 w-6 text-white mr-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
     <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 15l7-7 7 7" />
    </svg>
    <svg v-else xmlns="http://www.w3.org/2000/svg" @click="accordianHide(index)" class="h-6 w-6 text-white mr-4"
     fill="none" viewBox="0 0 24 24" stroke="currentColor">
     <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
    </svg>

   </header>

   <div v-if="isOpenOffering.includes(index)" class="flex flex-col mb-6 mx-10 my_table">
    <div class="overflow-x-auto">
     <div class="align-middle inline-block min-w-full">
      <div class="shadow overflow-hidden border-b-2 border-gray-200 sm:rounded-lg">
       <table class="min-w-full">
        <thead class="header-bg-color align-top">
         <tr>
          <th scope="col" class="">
          </th>

          <th scope="col"
           class="w-3/5 id_arrow px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider relative">
           Products
          </th>
          <th scope="col" class="w-1/5 px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider">
           Distributor
          </th>
          <th scope="col" class="w-1/5 px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider">
           Student Count
          </th>

          <th scope="col"
           class="relative w-1/5 px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider cursor-pointer ">
           <div @click="showNeededCases">
            Needed
            <span class="absolute right-0 w-fit cursor-pointer">
             <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-black mr-0" fill="none" viewBox="0 0 24 24"
              stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
             </svg>
            </span>
           </div>

           <div v-show="neededCasesVisible"
            class="absolute bg-[#38558e] min-w-[160px] left-0 text-white z-10 py-[14px] px-[15px] shadow-shadowb">
            <input type="radio" id="defaultOption" name="measurementOption" @click="resetToNeededRecipeAndUom"
             class="cursor-pointer">
            <label for="defaultOption" class="cursor-pointer ml-2">Default</label><br>

            <input type="radio" id="packwiseOption" name="measurementOption" @click="packWise" class="cursor-pointer">
            <label for="packwiseOption" class="cursor-pointer ml-2">Packwise</label><br>

            <input type="radio" id="casewiseOption" name="measurementOption" @click="caseWiseMeasurement"
             class="cursor-pointer">
            <label for="casewiseOption" class="cursor-pointer ml-2">Casewise</label><br>
           </div>
          </th>

          <th scope="col" class="w-1/5 px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider">
           on hand
          </th>
          <th scope="col" class="w-1/5 px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider">
           Estimated Needed
          </th>


          <th scope="col" class="w-1/5 px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider">
           Case
          </th>

          <!-- <th scope="col"
                                            class="w-1/5 px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider">
                                            View
                                        </th> -->



         </tr>
        </thead>
        <tbody>
         <!-- Oddd row -->
         <template v-for="(preferProduct, product) in preferProduct " :key="product">
          <tr class="bg-white " :class="{ 'bg-gray-300 opacity-70': preferProduct.ignoredCheckboxShow }"
           v-if="!preferProduct.hideFromFilter">
           <td class="px-6 py-4 whitespace-nowrap text-base font-bold underline id-color">
            <input v-if="preferProduct.ignoredCheckboxShow" v-model="preferProduct.ignored" type="checkbox" class="mr-3"
             @click="ignoreProdcut(index, product, preferProduct)">
           </td>

           <td class="px-6 py-4 whitespace-nowrap text-base font-bold underline id-color">
            <!-- Tyson-Frozen 1/4 Ib Beef Patty -->
            <a target="_blank" :href="route('products_edit', { id: preferProduct.product_id })"> {{
             preferProduct.name }}</a>
           </td>
           <td class="py-4 whitespace-nowrap text-base text-color td-background-color">
            <div class="relative focus:outline-none sm:w-60 w-50 xl:pl-4 pl-0 xl:mt-0 mt-4">
             <select @change="changeDistributor(index, product, preferProduct.distributor_id, preferProduct)"
              v-model="preferProduct.distributor_id"
              class="shadow-sm focus:border-none block sm:text-sm border-gray-300 rounded-lg w-full select-menu-height 2xl:text-base text-base text-gray-400">
              <option value="" :disabled="true">Select Distributor</option>
              <option v-for="(i, value)  in preferProduct.distributors" :value="value">{{ i.name }}</option>
             </select>
             <div v-show="preferProduct.distributor_error" class="validation_error_msg">Please select distributor.</div>
             <div
              class="absolute flex justify-center items-center searching-background-color select-menu-height w-9 text-white top-0 right-0 rounded-lg rounded-tl-none rounded-bl-none pointer-events-none">
              <i class="fa fa-sort-desc" aria-hidden="true"></i>
             </div>


            </div>

           </td>
           <td class="px-6 py-4 whitespace-nowrap text-base text-color td-background-color">
            {{ preferProduct.student_count }}
           </td>

           <td
            class="px-6 py-4 whitespace-nowrap text-base text-color td-background-color font-bold relative whitespace-break-spaces ">
            {{ formattedValue(preferProduct.needed_recipe_amount) }} {{
             preferProduct.recipe_amount_uom }}
            <div v-if="preferProduct.not_convertable" class="absolute right-0 top-7">
             <a title="Unit of measure mismatch" target="_blank"
              :href="route('products_edit', { id: preferProduct.product_id })">

              <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="#cb0000">
               <path fill-rule="evenodd"
                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                clip-rule="evenodd"></path>
              </svg>
             </a>
            </div>
           </td>

           <td class="px-6 py-4 whitespace-nowrap text-base text-color relative">
            <input v-model="preferProduct.needed" @change="changeOrderValue(index, product, preferProduct)"
             type="number"
             class="shadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-white sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2">
           </td>

           <td class="px-6 py-4 whitespace-nowrap text-base font-medium text-color font-bold">

            <!-- {{ estimatedNeeded(preferProduct.needed_recipe_amount, preferProduct.needed) }} {{ preferProduct.recipe_amount_uom }} -->

            <!-- {{formattedValue((preferProduct.needed_recipe_amount - (preferProduct.needed >
                                                preferProduct.needed_recipe_amount ? 0 : preferProduct.needed) ))}} -->

            <!-- {{formattedValue((preferProduct.needed_recipe_amount - (preferProduct.needed >
                                                preferProduct.needed_recipe_amount ? 0 : preferProduct.needed) ))}} -->

            {{ estimatedNeeded(preferProduct.needed_recipe_amount,
             preferProduct.needed) }}

            {{ preferProduct.recipe_amount_uom }}
           </td>


           <td class="px-6 py-4 whitespace-nowrap text-base font-medium text-color font-bold">
            {{ preferProduct.case_quantity }}
           </td>

           <!-- <td class="px-6 py-4 whitespace-nowrap text-base font-medium text-color font-bold">
                                            <span>i</span>
                                        </td> -->


          </tr>
         </template>


        </tbody>
       </table>

      </div>
     </div>
    </div>
   </div>
  </div>

  <div class="mt-6 px-10 flex justify-end items-center gap-2">
   <input type="checkbox" @click="distributorPreference">Update Product's Distributor Preference
  </div>
  <div class="bottom_button w-full sm:flex lg:flex-nowrap flex-nowrap lg:justify-end items-center  mb-6 px-10">

   <inertia-link :href="route('food-orders')" class="">
    <button
     class="cancel-button-color text-white font-bold py-1.5 xl:px-8 sm:px-8 px-4 lg:ml-6  ml-0 rounded lg:mt-0 sm:mt-0 xl:mt-5">
     CANCEL
    </button>
   </inertia-link>
   <inertia-link
    :href="route('CreateFoodOrders-next') + `?food_create_id=${this.food_create_id}&food_create_type=${this.food_create_type}`"
    class="">
    <button
     class="cancel-button-color text-white font-bold py-1.5 xl:px-8 sm:px-8 px-4 lg:ml-6 sm:ml-6 ml-6 rounded lg:mt-0 sm:mt-0 xl:mt-5">
     BACK
    </button>
   </inertia-link>
   <!-- <inertia-link :href="route('foodorderdetail-next')" class=""> -->
   <button @click="CreateFoodOrder"
    class="button-color text-white font-bold py-1.5 xl:px-8 sm:px-8 px-4 lg:ml-6 sm:ml-6 ml-6 rounded lg:mt-0 sm:mt-0 xl:mt-5">
    NEXT
   </button>
   <!-- </inertia-link> -->

  </div>


 </default-layout>
 <div v-show="false">
  <PrintFoodOrder :preferProducts="preferProducts" :formattedValue="formattedValue" :estimatedNeeded="estimatedNeeded"
   :food_order_name="food_order_name">
  </PrintFoodOrder>
 </div>

 <jet-dialog-modal :show="addProductsModal" @close="addProductsModal = false">
  <template #title>
   <div class="flex justify-between items-center">
    Search products to Add/Attach with ingredient
    <div class="relative md:w-56 ">
     <input class="border-2 border-gray-300 bg-white h-10 px-3 pr-10 rounded-lg text-sm focus:outline-none w-full"
      type="search" name="search_term" placeholder="Search" v-model="search_term"
      @keyup.enter="productSearchScriptModal">
     <button type="button" class="absolute right-0 top-0 mt-2 mr-4 outline-none" @click="productSearchScriptModal"><i
       class="fa fa-search" aria-hidden="true"></i></button>
    </div>
   </div>
  </template>
  <template #content>
   <TableIndexLayout>
    <div class="-my-2">
     <div class="py-2 align-middle inline-block px-2 w-full">
      <div class="shadow overflow-auto max-height">
       <table class="min-w-full">
        <thead class="header-bg-color">
         <tr>
          <th scope="col" class="px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider">
           PRODUCT NAME</th>
          <th scope="col" class="px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider">
           Source</th>
          <th scope="col" class="px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider">
           MANUFACTURER</th>
          <th scope="col" class="px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider">
           MFG#</th>
          <th scope="col" class="px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider">
           CN#</th>
          <th scope="col" class="px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider">
           Needed</th>
          <th scope="col" class="px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider">
           UOM</th>
          <th scope="col" class="px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider">
          </th>
         </tr>
        </thead>
        <tbody>
         <!-- Odd row -->
         <tr v-if="!searched_products.length" class="bg-white">
          <td class="px-6 py-4 whitespace-nowrap text-base text-color text-center" colspan="6">No Product Found</td>
         </tr>
         <tr v-for="(prod, index) in searched_products"
          :class="{ 'bg-white': index % 2 == 0, 'tr-background-color': index % 2 != 0 }" class="cursor-pointer">
          <td class="px-6 py-4 whitespace-nowrap text-base text-color td-background-color">
           <div class="tooltip">
            <div class="trim_text">{{ prod.name }}</div>
            <div class="top">
             {{ prod.name }}
             <i></i>
            </div>
           </div>
          </td>
          <td class="px-6 py-4 whitespace-nowrap text-base text-color">
           {{ prod.tenant_name }}
          </td>
          <td class="px-6 py-4 whitespace-nowrap text-base text-color">
           {{ prod.manufacturer }}
          </td>
          <td class="px-6 py-4 whitespace-nowrap text-base font-medium text-color">
           {{ prod.manufacturer_sku }}
          </td>
          <td class="px-6 py-4 whitespace-nowrap text-base font-medium text-color">
           {{ prod.cn_code }}
          </td>

          <td class="px-6 py-4 whitespace-nowrap text-base font-medium text-color">
           <input v-model="prod.needed_recipe_amount" type="number"
            class="shadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-white sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2">
           <div v-if="addProdcutbuttonClicked && prod.needed_recipe_amount == '' && clickedRowIndex == index"
            class="validation_error_msg">Required</div>

          </td>

          <td class="px-6 py-4 whitespace-nowrap text-base font-medium text-color">
           <select v-model="prod.recipe_amount_uom"
            class="cursor-pointer shadow-sm focus:border-none block sm:text-sm border-gray-300 rounded-lg select-menu-height">
            <optgroup label="Weight">
             <option value="Ounce">Ounce</option>
             <option value="Gram">Gram</option>
             <option value="LB">LB</option>
             <option value="Kilogram">Kilogram</option>
             <option value="Milligram">Milligram</option>
            </optgroup>

            <optgroup label="Volume">
             <option value="Gallon">Gallon</option>
             <option value="Quart">Quart</option>
             <option value="Pint">Pint</option>
             <option value="Cup">Cup</option>
             <option value="Fluid Ounce">Fluid Ounce</option>
             <option value="Tablespoon">Tablespoon</option>
             <option value="Litre">Litre</option>
             <option value="Millilitre">Millilitre</option>
             <option value="Teaspoon">Teaspoon</option>
            </optgroup>

            <optgroup label="Unit">
             <option value="Each">Each</option>
             <option value="Count">Count</option>
             <option value="Piece">Piece</option>
            </optgroup>
           </select>
           <div v-if="addProdcutbuttonClicked && prod.recipe_amount_uom == '' && clickedRowIndex == index"
            class="validation_error_msg">Required</div>



          </td>
          <td class="px-6 py-4 whitespace-nowrap id-color text-xl font-extrabold">
           <a :href="route('products_edit', { id: prod.id })" class="" target="_blank">
            <i class="fa fa-external-link pr-3" aria-hidden="true"></i>
           </a>
           <button type="button" class="" @click="addProductsAddScript(prod, index);">
            <i class="fa fa-plus pr-3" aria-hidden="true"></i>
           </button>
          </td>
         </tr>
        </tbody>
       </table>
      </div>
     </div>
    </div>
   </TableIndexLayout>
  </template>
  <template #footer>
   <jet-secondary-button @click="addProductsModal = false">Close</jet-secondary-button>
  </template>
 </jet-dialog-modal>

</template>

<script>
import DefaultLayout from "@/Layouts/DefaultLayout";
import Welcome from "@/Jetstream/Welcome";
import BreadcrumLayout from "@/Pages/Common/Breadcrumbs";
import PageTitleLayout from "@/Pages/Common/PageTitle";
import TableFilterLayout from "@/Pages/Common/TableFilters";
import TableIndexLayout from "@/Pages/Common/TableIndex";
import PrintFoodOrder from "@/Pages/FoodOrders/PrintCreateFoodOrderStep-3";
import JetDialogModal from '@/Jetstream/DialogModal';
import JetButton from '@/Jetstream/Button';
import JetSecondaryButton from '@/Jetstream/SecondaryButton';


export default {
 data() {
  return {
   isOpenOffering: [Object.keys(this.orginalPreferProducts)[0]],
   inputValue: '',
   weightInLB: '',
   distributorNotSelectCount: 0,
   umoVolumArray: ['Gallon', 'Litre', 'Quart', 'Pint', 'Cup', 'Fluid Ounce', 'Tablespoon', 'Teaspoon', 'Millilitre'],
   umoWeightArray: ['Kilogram', 'LB', 'Ounce', 'Gram', 'Milligram'],
   preferProducts: [],
   neededCasesVisible: false,
   updateDistributorPreference: false,
   filterIgnoredProducts: false,
   addProductsModal: false,
   searched_products: [],
   search_term: '',
   currentOffering: '',
   addProdcutbuttonClicked: false,
   clickedRowIndex: null,
  }
 },


 props: ['orginalPreferProducts', 'food_create_id', 'food_create_type', 'food_order_name'],

 components: {
  DefaultLayout,
  Welcome,
  BreadcrumLayout,
  PageTitleLayout,
  TableFilterLayout,
  PrintFoodOrder,
  TableIndexLayout,
  JetButton,
  JetSecondaryButton,
  JetDialogModal,
 },

 created() {
  this.preferProducts = JSON.parse(JSON.stringify(this.orginalPreferProducts));
  this.highestNeededRecipeAndUom(this.preferProducts);
 },



 methods: {

  productSearchScriptModal() {
   if (this.search_term == "") {
    this.$toast.error('Error: Search value required!');
   } else {
    this.addProdcutbuttonClicked = false;
    this.clickedRowIndex = null;
    let exist_products = [];
    // this.ing_products.forEach((value,index) => {exist_products.push(value['id']);});
    this.preferProducts[this.currentOffering].forEach((value, index) => {
     exist_products.push(value['product_id']);
    });

    this.hideShowLoader('show');

    axios.post('/food-order-product-search-modal', { term: this.search_term, ex_ids: exist_products, is_all: this.is_all })
     .then((response) => {
      this.hideShowLoader('hide');
      this.searched_products = response.data;
     })
     .catch(error => {
      this.hideShowLoader('hide');
      console.error(error);
     });
   }
  },

  hideShowLoader(types) {
   if (types == 'show') {
    document.getElementById('full_loader').style.display = 'flex';
   } else {
    document.getElementById('full_loader').style.display = 'none';
   }
  },

  addProductsAddScript(product_array, index) {
   if (product_array.recipe_amount_uom != ''
    // && product_array.needed_recipe_amount !=''
   ) {
    this.addProdcutbuttonClicked = false;
    this.clickedRowIndex = null;

    product_array.offering_id = this.preferProducts[this.currentOffering][0]['offering_id'];
    product_array.original_uom = product_array.recipe_amount_uom;
    product_array.original_needed_recipe_amount = product_array.needed_recipe_amount;

    console.log('product_array', product_array);
    this.preferProducts[this.currentOffering].push(product_array);
    this.orginalPreferProducts[this.currentOffering].push(product_array);
    console.log('addProductsAddScript', this.preferProducts[this.currentOffering]);
    this.searched_products.splice(index, 1);

    // const preferProduct = preferProducts[index][product];
    // this.preferProducts[this.currentOffering].indexOf(product_array)

    const oldUomType = this.$helpers.uomType(product_array.recipe_amount_uom);
    const oldUom = product_array.recipe_amount_uom;
    const initNeedeAmount = product_array.needed_recipe_amount;
    this.highestNeededRecipeAndUomOfProduct(initNeedeAmount, oldUomType, oldUom, product_array);

    // product_array.case_quantity  = this.calculateCaseQuantityForProduct(product_array);


    const caseQuantity = this.calculateCaseQuantityForProduct(product_array);

    console.log('caseQuantity', caseQuantity);
    product_array.case_quantity = caseQuantity;

    if (product_array.distributor_id && caseQuantity <= 0) {
     product_array.not_convertable = true;
    } else {
     product_array.not_convertable = false;
    }

    // if(product_array.is_usda)
    // {
    //     this.ing_products.push(product_array);
    //     this.searched_products.splice(index,1);
    //     this.avg_products_val_setup();

    // } else {
    //     this.error_product_array = product_array;
    //     this.addProductsModalWarring = true;
    //     console.log("this.error_product_array", this.error_product_array);
    // }
    // this.ing_products.push(product_array);
    // this.searched_products.splice(index,1);

    // this.avg_products_val_setup();

   } else {
    this.addProdcutbuttonClicked = true;
    this.clickedRowIndex = index;
   }

  },

  addProductsIngredientModalOpen(offering) {
   this.currentOffering = offering;
   console.log('offerincurrentOfferingg', this.currentOffering);
   this.addProductsModal = true;
   this.searched_products = [];
   this.search_term = '';
  },

  loadIsPrint() {
   // this.$refs.CalendarPrint.getCalenderDays();
   setTimeout(function () {
    var w = window.open("", "");
    w.document.write('<html><head><style type="text/css" media="print">');
    w.document.write('* {-webkit-print-color-adjust: exact !important; color-adjust: exact !important; }.header,.left_part,.month_year{display:flex}body{font-family:Lato,sans-serif!important;padding:20px}.header{align-items:center;justify-content:space-between;padding:30px 0;width:100%}.month_year{background:rgba(30,67,127);border-radius:15px 15px 0 0;padding:16px 12px 10px;align-items:flex-end;justify-content:space-between;width:100%;box-sizing:border-box}.month_name{color:#fff;font-size:24px;font-weight:700}table.table{width:100%;border:none;line-height:1.2}table.table thead{background:#132d56}table.table thead th{color:#fff;vertical-align:bottom;padding:5px;border-right:2px solid #233b61;font-size:12px}table.table thead th:last-child{border-right:none}table.table tr.grey_bar td{background:#e8e8e8;border-right:2px solid #d9d9d9;border-bottom-color:#d9d9d9;padding:7px 5px 6px 10px;font-size:14px;color:#454545;font-weight:600;text-align:left}table.table tr td{font-size:11px;color:#454545;text-align:center;padding:20px 5px 10px;border-style:solid;border-color:#eee #eee #cecece;border-width:2px 2px 2px 0;line-height:1.1}table.table tr td:first-child{border-left:2px solid #eee}table.table tr td p{margin:0}table.table tr td p+p{margin-top:5px}@page{size:auto;margin:0}');
    w.document.write('</style></head><body>');
    w.document.write(document.getElementById('print_food_order').innerHTML);
    w.document.write('</body></html>');
    w.document.close();
    w.focus();
    w.print();
    setTimeout(function () {
     w.close();
    }, 3000);
   }, 300);
  },



  ignoredProductsCount() {
   // Calculate the total number of ignored products
   let count = 0;

   Object.keys(this.preferProducts).forEach((prodcut) => {
    if (this.preferProducts[prodcut]) {
     Object.keys(this.preferProducts[prodcut]).forEach((productKey) => {
      const product = this.preferProducts[prodcut][productKey];
      if (product.ignored) {
       count++;
      }
     });
    }
   });
   return count;
  },
  showNeededCases() {
   this.neededCasesVisible = !this.neededCasesVisible;

  },
  distributorPreference() {
   this.updateDistributorPreference = !this.updateDistributorPreference;
  },

  highestNeededRecipeAndUom(preferProducts) {
   Object.keys(preferProducts).forEach((index) => {
    Object.keys(preferProducts[index]).forEach((product) => {
     const preferProduct = preferProducts[index][product];
     const oldUomType = this.$helpers.uomType(preferProduct.recipe_amount_uom);
     const oldUom = preferProduct.recipe_amount_uom;
     const initNeedeAmount = preferProduct.needed_recipe_amount;
     console.log("needed_recipe_amount1 ", initNeedeAmount, preferProduct.needed_recipe_amount);
     // console.log(initNeedeAmount, oldUomType, oldUom, preferProduct);
     this.highestNeededRecipeAndUomOfProduct(initNeedeAmount, oldUomType, oldUom, preferProduct);
     console.log("needed_recipe_amount2 ", initNeedeAmount, preferProduct.needed_recipe_amount);
     // preferProduct.case_quantity = this.calculateCaseQuantityForProduct(preferProduct);
     var result = this.calculateCaseQuantityForProduct(preferProduct);
     preferProduct.case_quantity = result;

     if (preferProduct.distributor_id != null && preferProduct.distributor_id != '' && preferProduct.distributors[preferProduct.distributor_id] && result <= 0) {
      console.log('distibutor not null ', preferProduct);
      preferProduct.not_convertable = true;
     }

     console.log("needed_recipe_amount3 ", initNeedeAmount, preferProduct.needed_recipe_amount);

    });
   });
  },

  highestNeededRecipeAndUomOfProduct(initNeedeAmount, oldUomType, oldUom, preferProduct) {
   preferProduct.recipe_amount_uom = oldUom;
   preferProduct.needed_recipe_amount = initNeedeAmount;
   console.log('oldUomoldUomoldUomoldUomoldUom', oldUom);
   if (oldUomType === 'Weight') {
    // var newUom = 'Ounce';
    for (let newUom of this.umoWeightArray) {
     var newRecipeAmount = this.$conversions.weight(initNeedeAmount, oldUom, newUom);
     if (newRecipeAmount >= 1) {
      preferProduct.needed_recipe_amount = newRecipeAmount;
      preferProduct.recipe_amount_uom = newUom;
      break;
     }
    }
   }

   if (oldUomType === 'Volume') {
    for (let newUom of this.umoVolumArray) {
     var newRecipeAmount = this.$conversions.volume(initNeedeAmount, oldUom, newUom);
     // console.log('newRecipeAmountnewRecipeAmountVolume', newRecipeAmount);
     if (newRecipeAmount >= 1) {
      preferProduct.needed_recipe_amount = newRecipeAmount;
      preferProduct.recipe_amount_uom = newUom;
      break;
     }
    }
   }
  },



  calculateCaseQuantityForProduct(preferProduct) {
   if (!preferProduct.distributor_id || preferProduct.distributor_id === '') {
    return 0;
   }

   const distributor = preferProduct.distributors[preferProduct.distributor_id];
   if (!distributor) {
    return 0;
   }

   console.log('distributor', distributor);

   const sizewithUnit = distributor['size'];
   const sizeAmount = parseInt(sizewithUnit.replace(/\D/g, ''));
   // const packs = distributor['pack'];
   const packs = distributor['pack'].replace(/\D/g, '');
   const sizeUnit = sizewithUnit.replace(/[0-9\s]/g, '');
   const newUom = this.getFullFormOfUnit(sizeUnit);


   if (newUom === 'Not Found') {
    return 0;
   }
   const oldUom = preferProduct.recipe_amount_uom;
   const initNeedeAmount = (preferProduct.needed_recipe_amount - (preferProduct.needed >
    preferProduct.needed_recipe_amount ? 0 : preferProduct.needed));


   if (oldUom === 'cases') {
    return initNeedeAmount;
   } else if (oldUom === 'packs') {
    return Math.ceil(initNeedeAmount / packs);
   }


   const result = this.calculateQuantityWithConversion(preferProduct, newUom, sizeAmount, packs, initNeedeAmount, oldUom);

   console.log('result', result);

   if (result > 0) {
    return Math.ceil(result / packs);
   } else {
    return 0;
   }

  },

  packWiseMeasurementOfProduct(preferProduct) {

   console.log('preferProduct counting', preferProduct);



   if (preferProduct.distributor_id != null && preferProduct.distributor_id != '' && preferProduct.distributors[preferProduct.distributor_id]) {
    console.log('if not null distributor id', preferProduct);

    const sizewithUnit = preferProduct.distributors[preferProduct.distributor_id]['size'];
    const sizeAmount = parseInt(sizewithUnit.replace(/\D/g, ''));
    const packs = preferProduct.distributors[preferProduct.distributor_id]['pack'];
    const sizeUnit = sizewithUnit.replace(/[0-9\s]/g, '');
    const newUom = this.getFullFormOfUnit(sizeUnit);

    if (newUom != 'Not Found') {

     const newUomType = this.$helpers.uomType(newUom);
     const oldUomType = this.$helpers.uomType(preferProduct.recipe_amount_uom);
     const oldUom = preferProduct.recipe_amount_uom;
     const initNeedeAmount = preferProduct.needed_recipe_amount;


     console.log('nnew unit ', newUom,);


     const result = this.calculateQuantityWithConversion(preferProduct, newUom, sizeAmount, packs, initNeedeAmount, oldUom);
     if (result > 0) {
      preferProduct.needed_recipe_amount = result;
      preferProduct.recipe_amount_uom = 'packs';
      preferProduct.not_convertable = false;

     } else {
      preferProduct.not_convertable = true;
     }
    } else {
     console.log('not_convertable');
     preferProduct.not_convertable = true;
    }
   }
  },



  calculateQuantityWithConversion(preferProduct, newUom, sizeAmount, packs, initNeedeAmount, oldUom) {

   const newUomType = this.$helpers.uomType(newUom);
   const oldUomType = this.$helpers.uomType(oldUom);

   console.log(`newUomType = ${newUomType},  oldUomType = ${oldUomType}, newUom = ${newUom}, oldUom =  ${oldUom}, sizeAmount =  ${sizeAmount}, initNeedeAmount = ${initNeedeAmount}, packs = ${packs}`);

   // console.log( newUom, sizeAmount, packs, initNeedeAmount, oldUom, oldUomType, newUomType);


   let newRecipeAmount;
   if (newUomType === oldUomType && newUomType === 'Weight') {
    newRecipeAmount = this.$conversions.weight(initNeedeAmount, oldUom, newUom);
    let neededPacks = Math.ceil(newRecipeAmount / sizeAmount);
    console.log('neededPacksneededPacks', neededPacks);
    return neededPacks;
   } else if (newUomType === oldUomType && newUomType === 'Volume') {
    newRecipeAmount = this.$conversions.volume(initNeedeAmount, oldUom, newUom);
    let neededPacks = Math.ceil(newRecipeAmount / sizeAmount);
    return neededPacks;
   } else if (newUomType === 'Weight' && oldUomType === 'Volume') {
    newRecipeAmount = this.$conversions.volumeToWeight(preferProduct, initNeedeAmount, oldUom, newUom, preferProduct.cuoms);
    console.log("newRecipeAmount", newRecipeAmount);
    if (newRecipeAmount != null) {
     let neededPacks = Math.ceil(newRecipeAmount / sizeAmount);
     return neededPacks;

    }
    return 0;
   } else if (newUomType === 'Volume' && oldUomType === 'Weight') {
    newRecipeAmount = this.$conversions.weightToVolume(preferProduct, initNeedeAmount, oldUom, newUom, preferProduct.cuoms);
    if (newRecipeAmount != null) {
     let neededPacks = Math.ceil(newRecipeAmount / sizeAmount);
     return neededPacks;
    }
    return 0;
   } else if (newUomType === 'Weight' && oldUomType === 'Unit') {
    if (preferProduct.nutrition_facts_weight_uom !== null && preferProduct.nutrition_facts_weight > 0) {
     if (preferProduct.nutrition_facts_unit != null && preferProduct.nutrition_facts_unit != '') {
      const productNutritionFactsWeight = parseFloat(preferProduct.nutrition_facts_weight);
      const productNutritionecipeAmountUom = preferProduct.needed_recipe_amount;
      const productNutritionFactsUnit = parseFloat(preferProduct.nutrition_facts_unit);
      const initNeedeAmount = ((productNutritionFactsWeight / productNutritionFactsUnit) * productNutritionecipeAmountUom);
      const oldUom = preferProduct.nutrition_facts_weight_uom;
      const newRecipeAmount = this.$conversions.weight(initNeedeAmount, oldUom, newUom);
      let neededPacks = Math.ceil(newRecipeAmount / sizeAmount);
      return neededPacks;
     }

    } else if (preferProduct.nutrition_facts_volume_uom !== null && preferProduct.nutrition_facts_volume > 0) {

     if (preferProduct.nutrition_facts_unit != null && preferProduct.nutrition_facts_unit != '') {
      const productNutritionFactsVolume = parseFloat(preferProduct.nutrition_facts_volume);
      const productNutritionecipeAmountUom = preferProduct.needed_recipe_amount;
      const productNutritionFactsUnit = parseFloat(preferProduct.nutrition_facts_unit);
      const initNeedeAmount = ((productNutritionFactsVolume / productNutritionFactsUnit) * productNutritionecipeAmountUom);

      const oldUom = preferProduct.nutrition_facts_volume_uom;
      const newRecipeAmount = this.$conversions.volumeToWeight(preferProduct, initNeedeAmount, oldUom, newUom, preferProduct.cuoms);
      let neededPacks = Math.ceil(newRecipeAmount / sizeAmount);
      return neededPacks;
     }
    }
   } else if (newUomType === 'Volume' && oldUomType === 'Unit') {
    if (preferProduct.nutrition_facts_volume_uom !== null && preferProduct.nutrition_facts_volume > 0) {
     if (preferProduct.nutrition_facts_unit != null && preferProduct.nutrition_facts_unit != '') {
      const productNutritionFactsVolume = parseFloat(preferProduct.nutrition_facts_volume);
      const productNutritionecipeAmountUom = preferProduct.needed_recipe_amount;
      const productNutritionFactsUnit = parseFloat(preferProduct.nutrition_facts_unit);
      const initNeedeAmount = ((productNutritionFactsVolume / productNutritionFactsUnit) * productNutritionecipeAmountUom);
      const oldUom = preferProduct.nutrition_facts_volume_uom;
      console.log("conversions to ", initNeedeAmount, oldUom, newUom);

      const newRecipeAmount = this.$conversions.volume(initNeedeAmount, oldUom, newUom);
      let neededPacks = Math.ceil(newRecipeAmount / sizeAmount);
      return neededPacks;
     }
    } else if (preferProduct.nutrition_facts_weight_uom !== null && preferProduct.nutrition_facts_weight > 0) {
     if (preferProduct.nutrition_facts_unit != null && preferProduct.nutrition_facts_unit != '') {
      const productNutritionFactsWeight = parseFloat(preferProduct.nutrition_facts_weight);
      const productNutritionecipeAmountUom = preferProduct.needed_recipe_amount;
      const productNutritionFactsUnit = parseFloat(preferProduct.nutrition_facts_unit);
      const initNeedeAmount = ((productNutritionFactsWeight / productNutritionFactsUnit) * productNutritionecipeAmountUom);
      const oldUom = preferProduct.nutrition_facts_weight_uom;
      console.log("conversions to ", initNeedeAmount, oldUom, newUom);

      newRecipeAmount = this.$conversions.weightToVolume(preferProduct, initNeedeAmount, oldUom, newUom, preferProduct.cuoms);
      let neededPacks = Math.ceil(newRecipeAmount / sizeAmount);
      return neededPacks;
     }
    }
   } else if (newUomType === 'Custom' && oldUomType === 'Weight' && preferProduct.cuoms) {
    let cuomsLength = preferProduct.cuoms.length;
    console.log('yes founc cuomsLength', cuomsLength);

    if (cuomsLength >= 1) {
     for (let i = 0; i < cuomsLength; i++) {
      if (preferProduct.cuoms[i].description1 == '||' + newUom + '||') {
       newRecipeAmount = this.$conversions.weight(initNeedeAmount, oldUom, preferProduct.cuoms[i].weight_units);
       let sc = preferProduct.cuoms[i].weight / preferProduct.cuoms[i].unit_amount;
       newRecipeAmount = newRecipeAmount / sc;
       let neededPacks = Math.ceil(newRecipeAmount / sizeAmount);
       return neededPacks;
      }
     }
    }
   } else if (newUomType === 'Custom' && oldUomType === 'Volume' && preferProduct.cuoms) {

    let cuomsLength = preferProduct.cuoms.length;
    if (cuomsLength >= 1) {
     for (let i = 0; i < cuomsLength; i++) {
      console.log('foundOne', preferProduct.cuoms[i].description1, newUom);
      if (preferProduct.cuoms[i].description1 == '||' + newUom + '||') {
       console.log('in else condition in else condition');
       // volumn to weight
       newRecipeAmount = this.$conversions.volumeToWeight(preferProduct, initNeedeAmount, oldUom, preferProduct.cuoms[i].weight_units, preferProduct.cuoms);

       console.log('newRecipeAmountnewRecipeAmount for custom unit', newRecipeAmount);
       // weight to gram
       let sc = preferProduct.cuoms[i].weight / preferProduct.cuoms[i].unit_amount;
       // console.log('sc', sc, newRecipeAmount, sizeAmount);

       newRecipeAmount = newRecipeAmount / sc;
       let neededPacks = Math.ceil(newRecipeAmount / sizeAmount);
       return neededPacks;
      }
     }
    }
    return 0;
   } else if (newUomType === 'Custom' && oldUomType === 'Custom' && preferProduct.cuoms) {

    console.log('this is part of custom to custom', preferProduct);
    let weight_units = null;
    for (let i = 0; i < preferProduct.cuoms.length; i++) {
     // custom to weight
     if (preferProduct.cuoms[i].description1 == '||' + oldUom + '||') {
      initNeedeAmount = initNeedeAmount / preferProduct.cuoms[i].unit_amount;
      weight_units = preferProduct.cuoms[i].weight_units;
      newRecipeAmount = this.$conversions.weight(initNeedeAmount, preferProduct.cuoms[i].weight_units, preferProduct.cuoms[i].weight_units);

      let neededPacks = Math.ceil(newRecipeAmount / sizeAmount);
      // console.log('this is part of custom to custom neededPacks', neededPacks);
      return neededPacks;
     }
    }

    // weight to custom
    for (let i = 0; i < preferProduct.cuoms.length; i++) {
     if (preferProduct.cuoms[i].description1 == '||' + newUom + '||') {
      // let smo = newRecipeAmount / preferProduct.cuoms[i].unit_amount;
      newRecipeAmount = this.$conversions.weight(initNeedeAmount, weight_units, preferProduct.cuoms[i].weight_units);
      newRecipeAmount = newRecipeAmount * preferProduct.cuoms[i].unit_amount;
      let neededPacks = Math.ceil(newRecipeAmount / sizeAmount);
      return neededPacks;
     }
    }
    return 0;
   }

   else {
    return 0;
   }
  },


  changeDistributor(index, pIndex, distributorId, pProduct) {
   console.log("preferProdcutpreferProdcut", this.preferProducts[index][pIndex]);
   if (this.orginalPreferProducts[index] && this.orginalPreferProducts[index][pIndex]) {
    console.log('thisorginalPreferProducts before', this.orginalPreferProducts);

    this.orginalPreferProducts[index][pIndex].distributor_id = distributorId;
    console.log('thisorginalPreferProducts after', this.orginalPreferProducts);
    const preferProduct = this.preferProducts[index][pIndex];
    const pProductRecipeAmountUom = preferProduct.recipe_amount_uom;

    if (preferProduct.distributor_id != null && preferProduct.distributor_id != '') {
     if (pProductRecipeAmountUom == 'packs' || pProductRecipeAmountUom == 'cases') {
      const originalProduct = this.orginalPreferProducts[index][pIndex];
      const oldUomType = this.$helpers.uomType(originalProduct.recipe_amount_uom);
      const oldUom = originalProduct.recipe_amount_uom;
      const initNeedeAmount = originalProduct.needed_recipe_amount;
      console.log("abcdedf", initNeedeAmount, oldUomType, oldUom, preferProduct);

      this.highestNeededRecipeAndUomOfProduct(initNeedeAmount, oldUomType, oldUom, preferProduct);
      console.log('preferProduct preferProduct preferProduct', preferProduct);
      this.packWiseMeasurementOfProduct(preferProduct);
      if (pProductRecipeAmountUom == 'cases') {
       const packs = preferProduct.distributors[preferProduct.distributor_id]['pack'];
       preferProduct.needed_recipe_amount = Math.ceil(preferProduct.needed_recipe_amount / packs);
       preferProduct.recipe_amount_uom = 'cases';
      }
     }

     // preferProduct.case_quantity  = this.calculateCaseQuantityForProduct(pProdcut);
     const result = this.calculateCaseQuantityForProduct(pProduct);
     preferProduct.case_quantity = result;
     preferProduct.not_convertable = (preferProduct.distributor_id != null && preferProduct.distributor_id != '' && result <= 0);
     preferProduct.case_quantity = isNaN(result) ? 0 : result;
    }

   }
  },



  resetToNeededRecipeAndUom() {
   this.neededCasesVisible = false;
   this.preferProducts = JSON.parse(JSON.stringify(this.orginalPreferProducts));
   this.highestNeededRecipeAndUom(this.preferProducts);
  },

  packWise() {
   this.neededCasesVisible = false;
   this.resetToNeededRecipeAndUom();
   const preferProducts = this.preferProducts;
   console.log('preferProducts in packWise', preferProducts);

   Object.keys(preferProducts).forEach((index) => {
    console.log('index in index loop', preferProducts[index]);
    Object.keys(preferProducts[index]).forEach((product) => {
     console.log('prodcut in index loop', product);
     // console.log(preferProducts[index][product]);
     const preferProduct = preferProducts[index][product];
     console.log('preferProduct in packwise', preferProduct);
     this.packWiseMeasurementOfProduct(preferProduct);
    });
   });

   console.log('not_convertable', this.preferProducts);
  },


  caseWiseMeasurement() {
   this.packWise();
   Object.keys(this.preferProducts).forEach((index) => {
    Object.keys(this.preferProducts[index]).forEach((product) => {
     const preferProduct = this.preferProducts[index][product];
     if (preferProduct.distributor_id != null && preferProduct.recipe_amount_uom == 'packs') {
      const packs = preferProduct.distributors[preferProduct.distributor_id]['pack'];
      preferProduct.needed_recipe_amount = Math.ceil(preferProduct.needed_recipe_amount / packs);
      if (isNaN(preferProduct.needed_recipe_amount)) {
       preferProduct.needed_recipe_amount = 0;
      }
      preferProduct.recipe_amount_uom = 'cases';

     }
    });
   });
  },


  getFullFormOfUnit(value) {
   switch (value.toUpperCase()) {
    case "OZ":
    case "OUNCE":
     return "Ounce";
    case "GRAM":
    case "GRM":
    case "G":
    case "GM":
     return "Gram";
    case "LB":
    case "POUND":
     return "LB";
    case "GAL":
    case "GALLON":
     return "Gallon";
    case "ML":
    case "Milliliter":
     return "Milliliter";
    case "DOZEN":
    case "DZ":
     return "Dozen";
    case "EA":
    case "Each":
     return "Each";
    case "IN":
    case "INCH":
     return "Inch";
    case "PINT":
    case "PT":
     return "Pint";
    case "BAGS":
     return "Bags";
    case "CT":
     return "CT";
    case "CASE":
     return "Case";
    case "QUART":
     return "Quart";
    case "CUP":
     return "Cup";
    case "FLUID OUNCE":
     return "Fluid Ounce";
    case "TABLESPOON":
     return "Tablespoon";
    case "TEASPOON":
     return "Teaspoon";
    default:
     return "Not Found";
   }
  },



  formattedValue(value) {
   console.log(value, typeof value, Number);
   if (Number.isInteger(value)) {
    return value;
   } else {
    return value.toFixed(2);
   }

  },
  addDistributorError() {
   this.distributorNotSelectCount = 0;

   if (this.food_create_type === 'site') {
    Object.keys(this.preferProducts).map((item, key) => {
     this.preferProducts[item].map((a) => {
      if (!a.ignored) {
       a.distributor_error = !a.distributor_id;
       this.distributorNotSelectCount += a.distributor_error ? 1 : 0;
      } else {
       a.distributor_error = false;
      }
     });
    });
   }

   if (this.food_create_type === 'group') {
    Object.keys(this.preferProducts).map((item, key) => {
     if (this.preferProducts[item]) {
      Object.keys(this.preferProducts[item]).map((i, k) => {
       if (!this.preferProducts[item][i].ignored) {
        this.preferProducts[item][i].distributor_error = !this.preferProducts[item][i].distributor_id;
        this.distributorNotSelectCount += this.preferProducts[item][i].distributor_error ? 1 : 0;
       } else {
        this.preferProducts[item][i].distributor_error = false;
       }
      });
     }
    });
   }
   console.log(this.distributorNotSelectCount);
   console.log(this.preferProducts);
  },

  // {{formattedValue((preferProduct.needed_recipe_amount - (preferProduct.needed >
  //                                         preferProduct.needed_recipe_amount ? 0 : preferProduct.needed) ))}}

  estimatedNeeded(neededRecipeAmount, needed) {

   let estimated_needed = neededRecipeAmount - (needed);
   estimated_needed = estimated_needed > 0 ? estimated_needed : 0;

   return this.formattedValue(estimated_needed);

   // return this.formattedValue((neededRecipeAmount - (needed > neededRecipeAmount ? 0 : needed)));
  },

  converterWeightToLB(index, product, neededRecipeAmount, needed, recipeAmountUom) {
   const estimated_needed = neededRecipeAmount - (needed > neededRecipeAmount ? 0 : needed);
   this.preferProducts[index][product]['weight_in_lb'] = estimated_needed;
   // this.weightInLB = this.$conversions.weight(this.estimatedNeeded(neededRecipeAmount, needed), recipeAmountUom, 'LB');
   this.weightInLB = estimated_needed;
   return this.weightInLB;
  },
  accordianShow(offering) {
   console.log('accordian show', offering);
   this.isOpenOffering.push(offering);
   // this.isOpenOffering = ! this.isOpenOffering;
   console.log('accordian array', this.isOpenOffering);
  },
  accordianHide(offering) {
   console.log('accordian hide', offering);
   const index = this.isOpenOffering.indexOf(offering);
   if (index > -1) { // only splice array when item is found
    this.isOpenOffering.splice(index, 1); // 2nd parameter means remove one item only
   }
   console.log('accordian array', this.isOpenOffering);
  },



  changeOrderValue(index, pIndex, pProduct) {
   const preferProduct = this.preferProducts[index][pIndex];
   const { needed, needed_recipe_amount } = preferProduct;
   preferProduct.needed = Math.max(0, needed); // Ensure needed is non-negative

   if (needed > needed_recipe_amount || needed < 0) {
    preferProduct.ignoredCheckboxShow = true;
   } else {
    preferProduct.ignoredCheckboxShow = false;
   }
   preferProduct.ignored = false; // This seems to be always set to false

   preferProduct.case_quantity = this.calculateCaseQuantityForProduct(pProduct);
  },

  ignoreProdcut(index, pIndex, pProdcut) {
   const preferProduct = this.preferProducts[index][pIndex];
   if (!this.filterIgnoredProducts) {
    preferProduct.hideFromFilter = !preferProduct.hideFromFilter;
   }
   preferProduct.ignored = !preferProduct.ignored;
   preferProduct.distributor_error = false;
  },

  filterIgnoredProdcuts() {
   this.filterIgnoredProducts = !this.filterIgnoredProducts;
   console.log('filterIgnoredProdcuts', this.filterIgnoredProducts);
   console.log('prefdfasfds', this.preferProducts);
   Object.keys(this.preferProducts).map((item, key) => {
    if (this.preferProducts[item]) {
     Object.keys(this.preferProducts[item]).map((i, k) => {
      if (this.preferProducts[item][i].ignored && this.filterIgnoredProducts) {
       this.preferProducts[item][i].hideFromFilter = false;
      }
      if (this.preferProducts[item][i].ignored && !this.filterIgnoredProducts) {
       this.preferProducts[item][i].hideFromFilter = true;
      }
     });
    }
   });

  },

  // ingnoredProdcut(index, pIndex, pProdcut){
  //     const preferProduct = this.preferProducts[index][pIndex];
  //     console.log('check preferProduct', preferProduct);
  //     // preferProduct.ignored = ! preferProduct.ignored;
  //     // console.log('preferProduct ignored', preferProduct.ignored);
  // },

  CreateFoodOrder() {
   // this.addDistributorError();

   // if(this.distributorNotSelectCount === 0){
   console.log(this.preferProducts);
   console.log('data', this.preferProducts);
   axios
    .post("/food-order/store/step-3", {
     food_create_id: this.food_create_id,
     food_create_type: this.food_create_type,
     data: this.preferProducts,
     update_distributor_preference: this.updateDistributorPreference,
    })
    .then((response) => {
     // console.log('food-order.store.step-4', response);
     if (response.data.status == 'success') {
      window.location.href = `create4?order_id=${response.data.data.id}`;
     }
     // console.log(response.data.status);
    })
    .catch((error) => console.error(error));
   // }
  },
 }

};
</script>

<style>
.title::after,
.title::before {
 content: '';
 position: absolute;
 right: 1.25em;
 top: 1.25em;
 width: 2px;
 height: 0.75em;
 background-color: #7A7572;
 transition: all 0.2s;
}

.content p {
 padding: 20px;
}

.min-height-third {
 min-height: 400px;
}

.span-text {
 font-size: 14px;
 color: #727272;
 padding-bottom: 5px;
}

.progress-bar>div {
 border-top-left-radius: 4px;
 border-bottom-left-radius: 4px;
 height: 23px;
 line-height: 23px;
}

.progress-text {
 font-size: 19px;
 color: #3f3f3f;
}

.progress-bar {
 background-color: #fff;
 border: 1px solid #cacaca;
 border-radius: 5px;
 height: 25px;
}

.bg-green-500 {
 background-color: #22af4b;
}

.sm\:text-sm {
 font-size: 0.850rem;
 line-height: 1.25rem;
}

.order-detail {
 color: #4a4a4a;
 font-size: 14px;
}

.w-52-rec {
 width: 13.2rem;
}

.cancel-button-color {
 background-color: #8b8b8b;
}

.input-background {
 background-color: #f8f8f8;
}

.text-base-heading {
 font-size: 14px;
}

.button-bg-color-wed-menu2-gray {
 border: none !important;
 min-height: 35px;
 min-width: 35px;
}

.menu1-background-color {
 background-color: #FAA43D;
}

.button-bg-color-wed-menu2 {
 background-color: #38558e;
 border: none !important;
 min-height: 35px;
 min-width: 35px;
}

.menu1-icon-color {
 color: #38558e;
}

.id-color-menu-edit {
 color: #F7A53A;
}

.bg-button-color {
 background-color: #cb0000;
}

.min-w-min-button {
 min-height: 26px;
 min-width: 53px;

}

.w-150 {
 width: 150px;
}

.max-w-0-menu1 {
 max-width: 4rem;
}

.bg-button-color-green {
 background-color: #22af4b;
}

.bg-button-color-gray {
 background-color: #636363;
}

.bg-hard-grey {
 background-color: #f4f4f4;
}

.font-size-edit {
 font-size: 10.5px;
}

.w-96-edit-recipes {
 width: 35rem;
}

.select-menu-height-edit2 {
 height: 2.8rem;
}

@media screen and (min-width: 1500px) {
 .id_arrow .fa-sort-desc:before {
  content: "\f0dd";
  position: absolute;
  top: 16px;
  left: 43px;
  padding-left: 7px;
  color: #219FD5;
 }

 .id_arrow .fa-sort-asc:before {
  content: "\f0de";
  color: #219FD5;
  padding-left: 7px;
  position: absolute;
  top: 16px;
  left: 43px;
 }
}

@media screen and (max-width: 1499px) {
 .id_arrow .fa-sort-asc:before {
  content: "\f0de";
  color: #219FD5;
  padding-left: 7px;
  position: absolute;
  top: 28px;
  left: 43px;
 }

 .id_arrow .fa-sort-desc:before {
  content: "\f0dd";
  position: absolute;
  top: 28px;
  left: 43px;
  padding-left: 7px;
  color: #219FD5;
 }
}

@media screen and (max-width: 1279px) {
 .searching-background-color {
  margin-left: 1.25rem;
  margin-right: 1.25rem;
 }

 .my_table {
  margin-left: 1.25rem;
  margin-right: 1.25rem;
 }

 .bottom_button {
  padding-right: 1.25rem;
  padding-left: 1.25rem;
 }
}

@media screen and (max-width: 570px) {

 .right-button,
 .order-detail {
  margin-top: 0.625rem;
 }
}

.validation_error_msg {
 font-weight: 400;
 margin: 6px 0 0 !important;
 color: red;
}

.max-height {
 max-height: 600px;
}

.trim_text {
 overflow: hidden;
 text-overflow: ellipsis;
 max-width: 250px;
}

.tooltip {
 display: inline-block;
 position: relative;
 text-align: left;
}

.tooltip .top {
 width: 250px;
 top: 50%;
 left: 100%;
 margin-left: 20px;
 transform: translate(0, -50%);
 padding: 5px 10px;
 color: #444444;
 background-color: #EEEEEE;
 font-weight: normal;
 font-size: 14px;
 border-radius: 5px;
 position: absolute;
 z-index: 99999999;
 box-sizing: border-box;
 box-shadow: 0 1px 8px rgba(0, 0, 0, 0.5);
 display: none;
 white-space: normal;
}

.tooltip:hover .top {
 display: block;
}

.tooltip .top i {
 position: absolute;
 top: 50%;
 right: 100%;
 margin-top: -12px;
 width: 12px;
 height: 24px;
 overflow: hidden;
}

.tooltip .top i::after {
 content: '';
 position: absolute;
 width: 12px;
 height: 12px;
 left: 0;
 top: 50%;
 transform: translate(50%, -50%) rotate(-45deg);
 background-color: #EEEEEE;
 box-shadow: 0 1px 8px rgba(0, 0, 0, 0.5);
}

.mb-6.bg-white.rounded-lg.overflow-hidden.shadow-xl.transform.transition-all.sm\:w-full.sm\:mx-auto.sm\:max-w-2xl {
 max-width: 90%;
}
</style>
